/**
 * 答题主流程（原站 Et 组件 / XUszk0 questMain）。
 *
 * 流程推进算法（逐字还原自 bundle 中的 for...of）：
 *   遍历 flow：
 *     - quest 且未作答       -> 立即渲染该题并结束遍历
 *     - quest 且已作答       -> 跳过，**并清空已缓冲的 guide**
 *     - guide 且已访问       -> 跳过
 *     - guide 且未访问       -> 收进缓冲区
 *   若缓冲里已攒了 guide 又遇到未答题 -> 本轮先不渲染（return 1 提前退出），
 *   保证引导不会和题目同时出现。
 *   遍历结束：缓冲区非空 -> 渲染第一个 guide；为空 -> null。
 *
 * 渲染门控（原站）：role 存在 且 store.ready 为真，否则内容区什么都不渲染。
 * 其中 ready 只由 /status 成功置位 —— 也就是未登录时不进入剧情。
 */
import { useMemo } from 'react';
import type { AccountContextValue } from '../Account/AccountContext';
import { actions, useQuizState } from '../../lib/store';
import { selectCurrent } from '../../lib/derive';
import { GuidePanel } from './GuidePanel';
import { QuestionPanel } from './QuestionPanel';
import { QuestDial } from './QuestDial';
import { QuestHeader } from './QuestHeader';
import './quest.css';

export interface QuestPageProps {
  account: AccountContextValue;
  inContainer?: boolean;
}

export function QuestPage({ account, inContainer }: QuestPageProps) {
  const { flow, story, ready, selection, visitedGuides, end, myResult } = useQuizState();

  const current = useMemo(
    () => (story ? selectCurrent(flow, story, selection, visitedGuides) : null),
    [flow, story, selection, visitedGuides],
  );

  const canRenderContent = !!account.role && ready && !!story;

  return (
    <>
      <QuestHeader
        account={account}
        onLogin={account.login}
        onSwitchRole={account.switchRole}
        onLogout={() => void account.logout()}
        inContainer={inContainer}
      />
      <div className="questMain">
        {canRenderContent &&
          (end ? (
            <QuestDial questions={story.questions} selection={selection} myResult={myResult} />
          ) : (
            current &&
            (current.kind === 'quest' ? (
              <QuestionPanel
                key={current.qId}
                quest={current.quest}
                qId={current.qId}
                onSubmit={(qId, aId) => void actions.submitQuest(qId, aId)}
              />
            ) : (
              <GuidePanel
                key={current.gId}
                guide={current.guide}
                gId={current.gId}
                selection={selection}
                onSubmit={(gId) => actions.completeGuide(gId)}
              />
            ))
          ))}
      </div>
    </>
  );
}
